import { useParams } from "react-router-dom";
import UserEventSection from "../components/EventSection";
import MessageSection from "../components/MessageSection";
import UserProfileSection from "../components/UserProfileSection";

export default function UserInternal() {
  let { userId } = useParams();

  return (
    <div className="flex grow flex-col items-center">
      {/* Projects */}
      <div className="flex mt-10 w-full lg:w-3/4">
        <UserProfileSection />
      </div>
      {/* Activity */}
      <div className="flex mt-10 w-full lg:w-3/4 ">
        <UserEventSection userId={userId} />
      </div>
      {/* Messages */}
      <div className="flex mt-10 w-full lg:w-3/4 ">
        <MessageSection userId={userId} />
      </div>
    </div>
  );
}
